import config from "config/index";

const getCurrentDate = () => (config.isStageMockoon ? new Date("2023-01-01T00:00:00.000Z") : new Date());

export {getCurrentDate};
